import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { isEmpty } from "lodash";

export function useIsCredentialRequirementConfigurationEnabled() {
  const credentialRequirementConfiguration = useCbhFlag(
    CbhFeatureFlag.CREDENTIAL_REQUIREMENT_CONFIGURATION,
    {
      defaultValue: [],
    }
  );

  return !isEmpty(credentialRequirementConfiguration);
}
